import { get_api_path } from "services/api";
import { getBinaryFromFile } from "utils/fileUtils";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("teacher/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(teacher_id) {
  const url = get_api_path("teacher/detail", {}, { teacher_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(teacher_id) {
  const url = get_api_path("teacher/delete", {}, { teacher_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(teacher_id, data) {
  const url = get_api_path("teacher/update", {}, { teacher_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("teacher/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function schedule(teacher_id, { query }) {
  const url = get_api_path("teacher/schedule", query, { teacher_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function image(teacher_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("teacher/image", {}, { teacher_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return { model };
};